import React from 'react';
import classNames from 'classnames';

interface ComponentProps {
  text: string;
  className?: string;
}

// One line of cell text that is cut short with an ellipsis when the column is too narrow for it,
// with the full value on hover. Keeps every row a single line instead of wrapping (see
// .contribution-truncated-text in _configs.scss). Called as a plain function from list.ts, like
// ContributionClientCell.
const TruncatedText = ({ text, className }: ComponentProps) => (
  <span className={classNames('contribution-truncated-text', className)} title={text}>
    {text}
  </span>
);

export default TruncatedText;
